module.exports = __webpack_public_path__ + "img/penta_icon.ca6045d3.png";